import React from 'react'

const PerContruction = () => {
    return (
        <>
            {/* Header Start */}
            <div className="container-fluid bg-breadcrumb">
                <ul className="breadcrumb-animation">
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                </ul>
                <div className="container text-center py-5" style={{ maxWidth: 900 }}>
                    <h3 className="display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">
                        Pre-Construction Services
                    </h3>
                    <ol
                        className="breadcrumb justify-content-center mb-0 wow fadeInDown"
                        data-wow-delay="0.3s"
                    >
                        <li className="breadcrumb-item">
                            <a href="/">Home</a>
                        </li>
                        <li className="breadcrumb-item active text-primary">
                            Pre-Construction Services
                        </li>
                    </ol>
                </div>
            </div>
            {/* Header End */}
            {/* About Start */}
            <div className="container-fluid overflow-hidden py-5 mt-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="position-relative overflow-hidden rounded-4 shadow-lg">
                                <img
                                    src="img/services/1.png"
                                    className="img-fluid w-100"
                                    alt="Pre-construction Services"
                                />
                                <div className="overlay-gradient" />
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="content-wrapper p-4">
                                <h1 className="display-5 mb-4 text-primary fw-semibold">
                                    Pre-Construction Planning Made Simple
                                </h1>
                                <p className="mb-4 lead text-dark">
                                    Our comprehensive pre-construction services ensure your project
                                    starts on the right foundation. We handle everything from initial
                                    planning to final preparations, making your construction journey
                                    smooth and efficient.
                                </p>
                                {/* <div class="mt-4">
                  <a href="#contact" class="btn btn-primary rounded-pill px-4 py-3">
                      Schedule a Consultation
                      <i class="fas fa-arrow-right ms-2"></i>
                  </a>
              </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* About End */}
        </>

    )
}

export default PerContruction